import http from "../../utils/http"

/**
 * รายการรีวิวสินค้า
 * @param {object} params
 */
export function goodsEvaluateList(params) {
    return http({
        url: "/api/goodsevaluate/page",
        data: params
    })
}

/**
 * จํานวนรีวิวสินค้า
 * @param {object} params
 */
export function goodsEvaluateCount(params) {
    return http({
        url: "/api/goodsevaluate/getgoodsevaluate",
        data: params
    })
}
